import { useFetchTrackingEvents } from "../hooks/use-queries";

export default function SurveyLink(props) {
  const { data: eventData } = useFetchTrackingEvents(props.id);
  const isCuted = eventData.filter((x) => x.type === "CUTED").length > 0;

  if (!isCuted) {
    return <></>;
  }

  return (
    <>
      <div className="bg-[#E6F8CC] mt-6 px-[4px] py-[14px] rounded-[8px] lg:w-[1195px] md:w-[1000px] ">
        <p className="text-[#787878] text-base leading-1 sm:leading-1 px-[20px]">
          Dalam rangka evaluasi dan meningkatkan kualitas program Gotong Royong dengan BerQurban, kami mohon masukan dan penilaian dari Bapak/Ibu melalui survey sederhana ini. <br />
          <a href="https://forms.office.com/r/r8rWFKzwQE" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
            Klik disini untuk mengikuti survey.
          </a>
        </p>
      </div>
    </>
  );
}
